export default function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-interpolate/src/number.js
// module id = 36
// module chunks = 0